import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';
import { environment as env } from 'environments/environments';

@Component({
    selector: 'registro-bien-cultural',
    templateUrl: 'registro-bien-cultural.component.html',
    imports:[
        CommonModule,
        MatIconModule,
        MatButtonModule,

        HasPermissionsDirective
    ]
})

export class RegistroBienCulturalComponent implements OnInit {
    seccion_prehispanica= env.TIPOLOGIA_ID_SECCION_PREHISPANICA
    seccion_hispanica_republicana= env.TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA
    seccion_bienes_inmuebles= env.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES

    constructor(private router: Router) { }

    ngOnInit() { }

    registrarBienCultural(seccion:number) {
        this.router.navigate([`bienes-culturales/registro/seccion/${seccion}`]);
    }
}